import { render, staticRenderFns } from "./NotifList.vue?vue&type=template&id=9756d878&scoped=true&"
import script from "./NotifList.vue?vue&type=script&lang=ts&"
export * from "./NotifList.vue?vue&type=script&lang=ts&"
import style0 from "./NotifList.vue?vue&type=style&index=0&id=9756d878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9756d878",
  null
  
)

export default component.exports